import {
  GET_SESSION_TOKEN_REQUEST,
  GET_SESSION_TOKEN_SUCCESS,
  GET_SESSION_TOKEN_FAILURE,

  SET_SESSION_TOKEN_REQUEST,
  SET_SESSION_TOKEN_SUCCESS,
  SET_SESSION_TOKEN_FAILURE,

  REMOVE_SESSION_TOKEN_REQUEST,
  REMOVE_SESSION_TOKEN_SUCCESS,
  REMOVE_SESSION_TOKEN_FAILURE
} from '../../constants/actions';

import config from '../../constants/config.js';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();

function getSessionTokenRequest () {
  return {
    type: GET_SESSION_TOKEN_REQUEST
  };
}
function getSessionTokenSuccess (token) {
  return {
    type: GET_SESSION_TOKEN_SUCCESS,
    token
  };
}
function getSessionTokenError (error) {
  return {
    type: GET_SESSION_TOKEN_FAILURE,
    error: error.cause || error
  };
}
function getSessionTokenFromCookie () {
  return dispatch => {
    dispatch(getSessionTokenRequest());
    try {
      let token = cookies.get(config.SESSION_COOKIE_NAME);
      dispatch(getSessionTokenSuccess(token));
    } catch (error) {
      dispatch(getSessionTokenError(error));
    }
  };
}

function setSessionTokenRequest () {
  return {
    type: SET_SESSION_TOKEN_REQUEST
  };
}
function setSessionTokenSuccess (token) {
  return {
    type: SET_SESSION_TOKEN_SUCCESS,
    token
  };
}
function setSessionTokenError (error) {
  return {
    type: SET_SESSION_TOKEN_FAILURE,
    error: error.cause || error
  };
}
function setSessionTokenToCookie (token) {
  return dispatch => {
    dispatch(setSessionTokenRequest());
    try {
      cookies
        .set(config.SESSION_COOKIE_NAME, token, {
          path: '/',
          domain: config.SESSION_COOKIE_DOMAIN,
          secure: config.SESSION_COOKIE_SECURE,
          maxAge: 60 * 60 * 24 * 30
        });
      dispatch(setSessionTokenSuccess(token));
    } catch (error) {
      dispatch(setSessionTokenError(error));
    }
  };
}

function removeSessionTokenRequest () {
  return {
    type: REMOVE_SESSION_TOKEN_REQUEST
  };
}
function removeSessionTokenSuccess (token) {
  return {
    type: REMOVE_SESSION_TOKEN_SUCCESS,
    token
  };
}
function removeSessionTokenError (error) {
  return {
    type: REMOVE_SESSION_TOKEN_FAILURE,
    error: error.cause || error
  };
}
function removeSessionTokenFromCookie () {
  return dispatch => {
    dispatch(removeSessionTokenRequest());
    try {
      cookies.remove(config.SESSION_COOKIE_NAME, {
        path: '/',
        domain: config.SESSION_COOKIE_DOMAIN,
        secure: config.SESSION_COOKIE_SECURE
      });
      dispatch(removeSessionTokenSuccess());
    } catch (error) {
      dispatch(removeSessionTokenError(error));
    }
  };
}

export function getSessionToken () {
  return (dispatch) => {
    return dispatch(getSessionTokenFromCookie());
  };
}

export function setSessionToken (token) {
  return (dispatch) => {
    return dispatch(setSessionTokenToCookie(token));
  };
}

export function removeSessionToken () {
  return (dispatch) => {
    return dispatch(removeSessionTokenFromCookie());
  };
}

export function getSessionInitCookie () {
  return cookies.get(config.SESSION_INIT_COOKIE_NAME);
}

export function setSessionInitCookie () {
  cookies.set(config.SESSION_INIT_COOKIE_NAME, config.SESSION_INIT_COOKIE_NAME, {
    path: '/',
    domain: config.SESSION_COOKIE_DOMAIN,
    secure: config.SESSION_COOKIE_SECURE,
    maxAge: 5
  });
}
